import { ButtonPrimary } from 'components/Button'
import Modal from 'components/Modal'
import ReferralInputPanel from 'pages/PointsProgram/ReferralInputPanel'
import React from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 24px;

  h2 {
    margin: 0;
  }
`

const ModalSignUp: React.FC<{
  isOpen: boolean
  onClose: () => void
  handleChange: any
  sign: () => void
  errorMsg: string
  inputValue: string
  loading: boolean
}> = ({ isOpen, onClose, handleChange, sign, errorMsg, inputValue, loading }) => {
  return (
    <Modal isOpen={isOpen} onDismiss={() => onClose()}>
      <Content>
        <h2>Sign up</h2>
        <ReferralInputPanel
          id="referral-input"
          value={inputValue}
          handleChange={handleChange}
          error={!!errorMsg}
          disabled={false}
        />

        {errorMsg && <p style={{ color: '#FF6871', margin: 0, fontSize: '12px' }}>Error: {errorMsg}</p>}
        <ButtonPrimary
          id="join-pool-button"
          style={{ padding: 16 }}
          as={'button'}
          onClick={sign}
          disabled={loading || inputValue.length === 0}
        >
          <Text fontWeight={400} fontSize={14} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            {loading ? 'Signing...' : 'Sign'}
          </Text>
        </ButtonPrimary>
      </Content>
    </Modal>
  )
}
export default ModalSignUp
